import axios from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    
    const [errors, setErrors] = useState({});
    const [inputValue, setInputValue] = useState({
        email: ""
    });
    const inputHandler = (e) => {
        const {name, value} = e.target;
        setInputValue({
            ...inputValue,
            [name]: value.trim()
        })
    }

    const validate = () => {
        let errors = {};
        const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/;

        if (!inputValue.email) {
            errors.email = "Email is required"
        } else if (emailReg.test(inputValue.email) === false) {
            errors.email = "Invalid Email";
        }
    
        return errors;
    };

    const submitForm = async (e) => {
        e.preventDefault()

        const formErrors = validate();
        setErrors(formErrors);

        const apiData = {
            email: inputValue.email
        }
        
        if (Object.keys(formErrors).length === 0) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/forgot-password`, apiData)
                const data = await response.data

                if(data.status === 1){
                    toast.success(data.message)
                    navigate('/verify-email')
                    localStorage.setItem('verifyEmail', data.email)
                } else {
                    toast.error(data.message)
                }

            } catch (error) {
                console.log('Error:', error)
            }
        }
    }

    return (
        <>
            <div className='main-content'>
                <div className='padding login-section'>
                    <div className='container'>
                        <div className='login-box mx-auto'>
                            <h4 className='text-center mb-1'>{t('Confirm your email')}</h4>
                            <p className='text-center mb-5'>{t('Enter the email associated with your account and we’ll send an email with code to reset your password')}</p>
                            
                            <form action="" className='form form1' onSubmit={submitForm}>
                                <div className='mb-3'>
                                    <input type="text" className="form-control" placeholder={t('Enter your email')} name="email" onChange={inputHandler} />
                                    {errors.email && <p className="error-text">{errors.email}</p> }
                                </div>

                                <div className='mt-3'>
                                    <button type='submit' className='btn btn1 w-100 mt-4'>{t("Send Code")}</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgotPassword
